/**
 * @generated SignedSource<<4b2985a90080bbfae06aa06bef301d94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubSwitcherFragment_session$data = {
  readonly staffAccessAvailable: boolean;
  readonly " $fragmentType": "ClubSwitcherFragment_session";
};
export type ClubSwitcherFragment_session$key = {
  readonly " $data"?: ClubSwitcherFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubSwitcherFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubSwitcherFragment_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "staffAccessAvailable",
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "de18d424d8b93965b48e52d6f2c8f6e1";

export default node;
